module.exports = __webpack_public_path__ + "static/media/beliefs-large.452eadc1.png";